
import { defineComponent, watch, reactive, ref, onMounted } from 'vue'
import IconVerified from '../IconVerified/index.vue'
import IconReply from '../IconReply/index.vue'
import IconRetweet from '../IconRetweet/index.vue'
import IconLike from '../IconLike/index.vue'
import IconShare from '../IconShare/index.vue'
import IconChevronLeft from '../IconChevronLeft/index.vue'
import IconChevronRight from '../IconChevronRight/index.vue'
import { Person, Source } from '@/types'
import { getCurrentTimeFormated } from '../../utils/date'

type Props = {
  tweet: Person;
  search: string;
}

export default defineComponent({
  components: {
    IconVerified,
    IconReply,
    IconRetweet,
    IconLike,
    IconShare,
    IconChevronRight,
    IconChevronLeft
  },
  props: {
    tweet: {
      type: Object as () => Props['tweet'],
      default: null
    },
    search: {
      type: String as () => Props['search'],
      default: ''
    }
  },
  emits: ['tweet-update', 'previous', 'next'],
  setup (props: Props, { emit }) {
    const tweetRef = ref(null)
    const state = reactive({
      date: getCurrentTimeFormated()
    })

    watch(() => props.search, () => {
      emit('tweet-update', tweetRef)
    })

    onMounted(() => {
      emit('tweet-update', tweetRef)
    })

    const onPrevious = () => emit('previous')

    const onNext = () => emit('next')

    return {
      state,
      tweetRef,
      onPrevious,
      onNext,
      Source
    }
  }
})
